module.exports = __webpack_public_path__ + "img/placeholder.d0e88041.jpg";